import { computed } from "vue";
import App from "@bloglovin/inspire-engine/App";

const VARIANT_GROUP_FEEDS = ["pages", "components"];

const indexByDestination = new Map();

function buildIndex(appName, destinationId) {
  const app = App.get(appName);
  const destinationPk = { id: destinationId };
  const byGroup = new Map();
  for (const feedName of VARIANT_GROUP_FEEDS) {
    app.getFeedStore("Destination", destinationPk, feedName).triggerInitialLoad();
    for (const item of app.getFeedItems("Destination", destinationPk, feedName) ?? []) {
      const entityPk = item.entityPk;
      const groupId = app.getEntityField("DynamicComponent", entityPk, "variantGroupId");
      if (!groupId) {
        continue;
      }
      if (app.getEntityField("DynamicComponent", entityPk, "status") === "inactive") {
        continue;
      }
      const members = byGroup.get(groupId) ?? [];
      members.push({
        id: Number(entityPk.id),
        name: app.getEntityField("DynamicComponent", entityPk, "name") ?? "",
      });
      byGroup.set(groupId, members);
    }
  }
  for (const members of byGroup.values()) {
    members.sort((left, right) => left.id - right.id);
  }
  return byGroup;
}

export function variantGroupMembers(appName, destinationId, variantGroupId) {
  if (!variantGroupId) {
    return [];
  }
  if (!destinationId) {
    throw new Error(`variantGroupMembers: variant group "${variantGroupId}" was asked for without a`
      + " destination. A variant group only exists within one destination, so the caller must pass"
      + " the owning DynamicComponent's destination id — returning an empty group here would read"
      + " as \"this component has no variants\" and silently hide every sibling.");
  }
  const cacheKey = `${appName}:${destinationId}`;
  let index = indexByDestination.get(cacheKey);
  if (!index) {
    index = computed(() => buildIndex(appName, destinationId));
    indexByDestination.set(cacheKey, index);
  }
  return index.value.get(variantGroupId) ?? [];
}
